import { extendTheme } from '@chakra-ui/react'
import '@fontsource/manrope'

const theme = extendTheme({
  fonts: {
    body: 'Manrope, system-ui, sans-serif',
    heading: 'Manrope, system-ui, sans-serif',
    mono: 'Manrope, system-ui, sans-serif'
  },
  components: {
    Button: {
      variants: {
        'btn-quilmes': {
          bg: 'linear-gradient(90deg, #DB580B 0%, #FF883F 100%)',
          w: '100%',
          textColor: 'white',
          size: 'lg',
          marginTop: 3,
          letterSpacing: '0.5px',
          fontSize: '0.8rem',
          transitionProperty: 'none',
          _hover: {
            bg: '#DB580B'
          }
        }
      }
    }
  }
})

export default theme
